@if (reminder) {
  <div class="grid-container margin-top">
    <button class="linkButton margin-bottom" routerLink="/admin/reminders"><span class="ascii-full-height">&laquo;</span> All Reminders</button>
    <div class="grid-x grid-margin-x grid-margin-y">
      <div class="cell medium-12">
        @if (!isEditingReminderName) {
          <div class="margin-bottom heading-border">
            <div class="flex">
              <h2 class="display-inline-block no-margin" aria-label="Reminder Name">&#42; {{reminder.name}}</h2>
              <button (click)="isEditingReminderName = true" class="minor-margin-left no-margin-bottom" aria-label="Edit Reminder Name" title="Edit Reminder Name">
                <svg-icon icon="icon-pencil" class="dark-gray" aria-hidden="true"></svg-icon>
              </button>
            </div>
            <!--<div *ngIf="hasGroupNameError">
            <small class="error" *ngIf="groupDetailsForm.get('nameInput').hasError('required')">
              Reminder name is required
            </small>
          </div>-->
        </div>
      } @else {
        <div class="flex margin-bottom">
          <label for="nameInput" class="show-for-sr">Enter Reminder Name</label>
          <input type="text" id="nameInput" placeholder="Enter Reminder Name" required [(ngModel)]="reminder.name" class="no-margin" />
          <!-- [disabled]="hasGroupNameError" -->
          <button (click)="isEditingReminderName = false" class="minor-margin-left no-margin-bottom" title="Save Reminder Name" aria-label="Save Reminder Name">
            <svg-icon icon="icon-save" class="small dark-gray" aria-hidden="true"></svg-icon>
          </button>
        </div>
        <!--<div class="error-container" *ngIf="hasGroupNameError">
        <small class="error" *ngIf="groupDetailsForm.get('nameInput').hasError('required')">
          Group name is required
        </small>
      </div>-->
    }
  </div>
  <div class="cell small-12">
    <div class="grid-x grid-margin-x align-middle">
      <div class="cell small-12 medium-4">
        <label class="vertical-align-middle minor-margin-right" for="active">Active:</label>
        <input class="no-margin-bottom vertical-align-middle" name="active" id="active" type="checkbox" [(ngModel)]="reminder.active" />
      </div>
      <div class="cell small-12 medium-8">
        <fieldset [ngClass]="{'required' : reminder.active}" id="deliveryMethods">
          <legend class="no-margin" [ngClass]="{'required' : reminder.active}">Delivery Methods:</legend>
          @for (d of allDeliveryMethods; track d) {
            <span style="display:inline-block;white-space:nowrap">
              <input class="no-margin vertical-align-middle" type="checkbox" [attr.id]="d.id" [checked]="reminderHasDeliveryMethod(d.id)" (change)="deliveryMethodsUpdated(d.id, $event.target.checked)">
              <label class="display-inline-block" [attr.for]="d.id">{{d.text}}</label>
            </span>
          }
        </fieldset>
      </div>
    </div>
  </div>
  @if (isNotification()) {
    <div class="cell small-12 medium-12">
      <fieldset>
        <legend class="cell small-12 required">Groups to Notify:</legend>
        <div class="grid-x grid-margin-x">
          <div class="cell medium-5">
            <label>Available Groups:</label>
            <select class="no-margin-bottom" multiple [(ngModel)]="selectedAddGroupsIdList">
              @for (g of nonGroups; track g) {
                <option value="{{g.id}}">{{g.displayName}}</option>
              }
            </select>
          </div>
          <div class="cell medium-2 text-align-center">
            <div class="grid-x">
              <div class="cell addGroupCell">
                <button class="button" (click)="addGroup()">&gt;&gt;</button>
              </div>
              <div class="cell medium-12">
                <button class="button no-margin-bottom" (click)="removeGroup()">&lt;&lt;</button>
              </div>
            </div>
          </div>
          <div class="cell medium-5">
            <label>Notified Groups:</label>
            <select class="no-margin-bottom" multiple [(ngModel)]="selectedRemoveGroupsIdList">
              @for (g of inGroups; track g) {
                <option value="{{g.id}}">{{g.displayName}}</option>
              }
            </select>
          </div>
        </div>
      </fieldset>
    </div>
  }
  <div class="cell small-12">
    <fieldset>
      <legend>Timeframe:</legend>
      <div class="grid-x grid-margin-x align-middle">
        <div class="cell small-12 medium-4">
          <label for="timeframe" [ngClass]="{'required' : reminder.active}">Number of days:</label>
          <input type="number" class="no-margin-bottom" id="timeframe" [(ngModel)]="reminder.timeframe" />
        </div>
        <div class="cell small-12 medium-8">
          <input type="checkbox" class="no-margin vertical-align-middle" id="inBusinessDays" [(ngModel)]="reminder.timeframeIsInBusinessDays" />
          <label class="display-inline-block" for="inBusinessDays">Business days</label>
          <input type="checkbox" class="no-margin vertical-align-middle" id="withinTimeframe" [checked]="!reminder.getEverythingWithinTheTimeframe" (change)="toggleGetEverythingWithinTheTimeframe()" />
          <label class="display-inline-block" for="withinTimeframe">Only trigger on items at exact date interval.</label>
        </div>
      </div>
    </fieldset>
  </div>
  <div class="cell small-12 medium-6 large-4">
    <label for="reminderType">Reminder Type:</label>
    <select id="reminderType" class="no-margin-bottom" (change)="typeChanged($event.target.value)" [(ngModel)]="reminder.type">
      @for (type of allReminderTypes; track type) {
        <option [value]="type.id">{{type.text}}</option>
      }
    </select>
  </div>
  <div class="cell small-12 medium-6 large-4">
    <label for="templateType" [ngClass]="{'required' : reminder.active}">Template Type:</label>
    <select id="templateType" class="no-margin-bottom" (change)="templateChanged($event.target.value)" [(ngModel)]="reminder.reportTemplateId">
      @for (template of filteredTemplateTypes; track template) {
        <option [value]="template.id">{{template.name}}</option>
      }
    </select>
  </div>
  @if (isRegularOrCertified()) {
    <div class="cell small-12 medium-12 large-12">
      <label for="documentTypeId" class="required">Document Type Name:</label>
      <input type="text" class="no-margin-bottom" [disabled]="true" [(ngModel)]="selectedTemplateDocumentType" />
    </div>
  }
  <div class="cell small-12 medium-12 large-12">
    When selecting notification as a Delivery Method, the notification text will be the template's content stripped of all HTML formatting.
  </div>
</div>
</div>
}